<template>
    <div v-if="value">
        <div class="modal backdrop" ref="modal" :class="{'show': value}">
            <div class="modal-mask">
                <div class="modal-dialog" role="document" :style="{ 'max-width': width }">
                    <div class="modal-content">
                        <div v-if="showTitle || showCloseButton" class="modal-header">
                            <h5 v-if="showTitle" class="modal-title">{{ title }}</h5>
                            <button v-if="showCloseButton" type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="() => onClose()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div class="modal-body">
                            <slot v-if="value"></slot>
                        </div>

                        <div v-if="showPrimaryButton || showSecondaryButton" class="modal-footer">
                            <Button v-if="showPrimaryButton" type="button" class="btn btn-primary"  v-on:click="() => onPrimaryClick()">
                                {{ primaryButtonText }}
                            </Button>

                            <Button v-if="showSecondaryButton" type="button" class="btn btn-secondary" data-dismiss="modal" v-on:click="() => onSecondaryClick()">
                                {{ secondaryButtonText }}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Button from './Button'

export default {
    components: { Button },
    props: {
        value: {
            required: true,
        },
        showPrimaryButton: {
            type: Boolean,
            required: false,
            default: true
        },
        showSecondaryButton: {
            type: Boolean,
            required: false,
            default: true
        },
        showCloseButton: {
            type: Boolean,
            required: false,
            default: true
        },
        showTitle: {
            type: Boolean,
            required: false,
            default: true
        },
        primaryButtonText: {
            type: String,
            required: false,
            default: 'Salvar'
        },
        secondaryButtonText: {
            type: String,
            required: false,
            default: 'Cancelar'
        },
        title: {
            type: String,
            required: false,
            default: 'Modal'
        },
        onClose: {
            type: Function,
            required: false,
            default: () => {}
        },
        onPrimaryClick: {
            type: Function,
            required: false,
            default: () => {}
        },
        onSecondaryClick: {
            type: Function,
            required: false,
            default: () => {}
        },
        width: {
            type: String,
            required: false,
            default: '600px'
        },
    },
    data(){
        return {
            content: this.value,
            randomId: null,
        };
    },
    computed: {
    },
    methods: {
    },
    mounted() {
    }
}
</script>

<style scoped lang="scss">
.show {
    display: block !important;
}

.backdrop {
    background-color: #000000bb;
}

.close {
    background: none;
    color: inherit;
    border: none;
    padding: 10px 15px;
    line-height: 40px;
    outline: inherit;
    font-size: 32px;
}

.modal-body {
    max-height: calc(100vh - 150px);
    overflow-y: auto;
}
</style>
